import { render, staticRenderFns } from "./destroy-team.vue?vue&type=template&id=4f436fe1&scoped=true&"
import script from "./destroy-team.vue?vue&type=script&lang=js&"
export * from "./destroy-team.vue?vue&type=script&lang=js&"
import style0 from "./destroy-team.vue?vue&type=style&index=0&id=4f436fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f436fe1",
  null
  
)

export default component.exports